import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MissionClientService } from '@rsm/client/mission-client';

@Injectable({
  providedIn: 'root',
})
export class ProfilePhotoStoreService {
  private readonly photoSubject = new BehaviorSubject<string | null>(null);
  readonly photo$ = this.photoSubject.asObservable();
  private loading = false;

  constructor(private missionClientService: MissionClientService) {}

  getPhoto(): string | null {
    return this.photoSubject.value;
  }

  loadApprovedPhoto(force = false): void {
    if (this.loading) {
      return;
    }

    if (!force && this.photoSubject.value !== null) {
      return;
    }

    this.loading = true;
    this.missionClientService.getCurrentApprovedProfilePhoto().subscribe({
      next: (response) => {
        this.photoSubject.next(response?.imageUrl || null);
        this.loading = false;
      },
      error: () => {
        this.photoSubject.next(null);
        this.loading = false;
      },
    });
  }

  setPhoto(photoUrl: string | null): void {
    this.photoSubject.next(photoUrl);
  }
}
